<!-- <div class="row pt-3" *ngIf="StudyMaterialresponse">
  <div class="col-12">
    <div class="scroll-style border">
      <div class="d-flex border-bottom">
        <div class="px-1 text-left Rl-hdr ">No.</div>
        <div class="px-1 text-left Rl-hdr ">
          <p class="Rl-col-2">Material Type</p>
        </div>
        <div class="px-1 text-left Rl-hdr ">
          <p class="Rl-col-3">Name</p>
        </div>
        <div class="px-1 text-left Rl-hdr ">
          <p class="Rl-col-4">Status</p>
        </div>
        <div class="px-1 text-left Rl-hdr ">
          <p class="Rl-col-2">Entered By</p>
        </div>
        <div class="px-1 text-left Rl-hdr ">
          <p class="Rl-col-2">Entered Date</p>
        </div>
        <div class="px-1 text-left Rl-hdr ">
          <p class="Rl-col-2">Reviewed By</p>
        </div>
        <div class="px-1 text-left Rl-hdr ">
          <p class="Rl-col-1">Reviewed Date</p>
        </div>

      </div>

      <div class="d-flex invRow"
        *ngFor="let s of StudyMaterialresponse; let i = index">
        <div class="px-2 text-right pt-1 pb-1  border-bottom">{{i+1}}</div>
        <div class="px-1 text-left pt-1 pb-1  border-bottom">
           <p class="Rl-col-2">{{s.File_Type_Name}}</p>

        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom" (click)="EditButton(s)">
          <p class="Rl-col-3 link">{{s.Study_Material_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-4">{{s.Study_Material_Status_Type_Name}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-2">{{s.Created_By}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-2">{{s.Creation_Date | date: "dd-MMM-yyyy"}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-2">{{s.Created_By}}</p>
        </div>
        <div class="px-1 text-left pt-1 pb-1 border-bottom">
          <p class="Rl-col-1">{{s.Creation_Date | date: "dd-MMM-yyyy"}}</p>
        </div>
        </div>
      </div>

      <div class="d-flex" *ngIf="!StudyMaterialresponse">
        <div class="p-3 m-3">No search results</div>
      </div>

    </div>
  </div> -->
  <div class="row pt-3" *ngIf="StudyMaterialresponse">
    <div class="col-12">
      <div class="table-responsive">
      <table class="table table-sm table-bordered table-hover" style="margin-bottom: 0" >
        <thead>
          <tr class="table-secondary">
            <th class="col-md-1 centertext">Material Type</th>
            <th class=" centertext">ID</th>
            <th class="col-md-6 centertext">Name</th>
            <th class="col-md-2 centertext">Practice Questions</th>
            <th class="col-md-1 centertext">Status</th>
            <th class="col-md-1 centertext">Entered By</th>
            <th class="col-md-1 centertext">Entered Date</th>
            <th class="col-md-1 centertext">Reviewed By</th>
            <th class="col-md-1 centertext">Reviewed Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of StudyMaterialresponse;let i=index" (click)="EditButton(s)">
            <td class="centertext">{{s?.Study_Material_Type_Name}}</td>
            <td class="centertext">{{s.Study_Material_Id}}</td>
            <td class='link' >{{s.Study_Material_Name}}</td>
            <td class='link centertext' (click)="AssignPracticeQuestions(s);$event.stopPropagation()" >Assign Practice Questions</td>
            <td class="centertext">{{s.Study_Material_Status_Type_Name}}</td>
            <td class="centertext">{{s.Created_By}}</td>
            <td class="centertext">{{s.Creation_Date | date: "dd/MM/yy"}}</td>
            <td class="centertext">{{s.Created_By}}</td>
            <td class="centertext">{{s.Creation_Date | date: "dd/MM/yy"}}</td>

          </tr>
        </tbody>
      </table>
    </div>
</div>
</div>
